// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPaymentMethodConfigDto
 */
export interface IPaymentMethodConfigDto {
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodConfigDto
     */
    payment_method_type?: IPaymentMethodConfigDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodConfigDto
     */
    payment_employee_fee?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentMethodConfigDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IPaymentMethodConfigDto interface.
 */
export function instanceOfIPaymentMethodConfigDto(value: object): value is IPaymentMethodConfigDto {
    return true;
}

export function IPaymentMethodConfigDtoFromJSON(json: any): IPaymentMethodConfigDto {
    return IPaymentMethodConfigDtoFromJSONTyped(json, false);
}

export function IPaymentMethodConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentMethodConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'payment_employee_fee': json['payment_employee_fee'] == null ? undefined : json['payment_employee_fee'],
    };
}

export function IPaymentMethodConfigDtoToJSON(json: any): IPaymentMethodConfigDto {
    return IPaymentMethodConfigDtoToJSONTyped(json, false);
}

export function IPaymentMethodConfigDtoToJSONTyped(value?: IPaymentMethodConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_type': value['payment_method_type'],
        'payment_employee_fee': value['payment_employee_fee'],
    };
}

